export var GLTribunalCaseType;
(function (GLTribunalCaseType) {
    GLTribunalCaseType["GLBetalingspaakrav"] = "GL-BETALINGSPAAKRAV";
    GLTribunalCaseType["GLStaevning"] = "GL-STAEVNING";
    GLTribunalCaseType["GLFogedBegaering"] = "GL-FOGED_BEGAERING";
})(GLTribunalCaseType || (GLTribunalCaseType = {}));
//# sourceMappingURL=greenland.js.map